import React from 'react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { Navigate, useLocation } from 'react-router-dom';
import auth from '../../Firebase/Firebase';
import Loader from '../Shared/Loader';


const PrivateRoute = ({children}) => {
    const [user, loading]= useAuthState(auth);
    const location= useLocation();

    if(loading){
        return <Loader/>
    }

    if(!user){
        return <Navigate to='/login' state={{from: location}} replace></Navigate>
    }

    return children;
};

export default PrivateRoute;